

export default function ChatConfig () {

    return(
        <div className='config-container'>
            <div className="config-sub-container">
                <h4>Privacidad</h4>
            </div>
            <div className="config-sub-container">
                <h4>Notificaciones</h4>
            </div>
            <div className="config-sub-container">
                <h4>Otros</h4>
            </div>
        </div>
    );
}